module.exports = __webpack_public_path__ + "img/loading.9c0fe61d.gif";